// extracted by mini-css-extract-plugin
export default {"OrderPadInput":"OrderPadInput_OrderPadInput__GkL+t"};